<template>
  <!-- Dashboard Sidebar
	================================================== -->
  <div class="dashboard-sidebar">
    <div class="dashboard-sidebar-inner" data-simplebar>
      <div class="dashboard-nav-container">
        <!-- Responsive Navigation Trigger -->
        <a href="#" class="dashboard-responsive-nav-trigger">
          <span class="hamburger hamburger--collapse">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </span>
          <span class="trigger-title">Dashboard Navigation</span>
        </a>

        <!-- Navigation -->
        <div class="dashboard-nav">
          <div class="dashboard-nav-inner">
            <ul data-submenu-title="" class="m-0">
              <li class="" :class="{ active: $route.name === 'UserDashboard' }">
                <router-link to="/dashboard">
                  <i class="icon-material-outline-dashboard"></i> Dashboard
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'Messages' }">
                <router-link to="/dashboard/messages">
                  <i class="icon-feather-bell"></i> Notifications
                  <!-- <span class="nav-tag">2</span> -->
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'SavedJobs' }">
                <router-link to="/dashboard/saved-jobs">
                  <i class="icon-material-outline-star-border"></i> Saved Jobs
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'Reviews' }">
                <router-link to="/dashboard/reviews">
                  <i class="icon-material-outline-rate-review"></i>
                  Reviews
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'Payments' }">
                <router-link to="/dashboard/payments"
                  ><i class="icon-material-outline-account-balance-wallet"></i>
                  Earnings</router-link
                >
                <ul>
                  <li><router-link to="/dashboard/jobs/postnewjob">Post a Job</router-link></li>
                  <li><a href="/dashboard/jobs/allmyjobs">All your jobs</a></li>
                  <li><router-link to="/dashboard/jobs/draftprojects">Drafts</router-link></li>
                  <li><a href="#">Cancelled</a></li>
                  <li><a href="#">Completed</a></li>
                  <li><a href="#">Running</a></li>
                </ul>
              </li>
              <li
                ><a href="#"><i class="icon-material-outline-assignment"></i> Applications</a>
                <ul>
                  <li><a href="#">Manage Applications</a></li>
                </ul>
              </li>
            </ul>

            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <button
                    class="ml-3 btn-block text-left"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <i class="icon-material-outline-dashboard"></i>Employer
                  </button>
                </div>

                <div
                  id="collapseOne"
                  class="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <ul class="m-0">
                    <li class="ml-3">
                      <router-link to="/dashboard/jobs/postnewjob"
                        >Post a Job</router-link
                      >
                    </li>
                    <li class="ml-3"><a href="/dashboard/jobs/allmyjobs">All your jobs</a></li>
                    <li class="ml-3"><router-link to="/dashboard/jobs/draftprojects">Drafts</router-link></li>
                    <li class="ml-3"><a href="/dashboard/jobs/publishedjobs">Published</a></li>
                    <li class="ml-3"><a href="/dashboard/jobs/cancelledprojects">Cancelled</a></li>
                    <li class="ml-3"><a href="/dashboard/jobs/completedprojects">Completed</a></li>
                    <li class="ml-3"><a href="/dashboard/jobs/runningprojects">Running</a></li>
                  </ul>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <button
                    class="ml-3 btn-block text-left collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <i class="icon-material-outline-dashboard"></i> Freelancer
                  </button>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <ul class="m-0">
                    <li class="ml-3"><a href="/dashboard/allapplications">My Applications</a></li>
                    <li class="ml-3"><a href="/dashboard/assignedapplications">Assigned Applications</a></li>
                    <li class="ml-3">
                      <a href="/dashboard/completedapplications">Completed Applications</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Employer -->
            <ul data-submenu-title="Account">
              <li :class="{ active: $route.name === 'UserSettings' }">
                <router-link to="/dashboard/settings"
                  ><i class="icon-material-outline-settings"></i>
                  Settings</router-link
                >
              </li>
              <li>
                <a href="#"
                  ><i class="icon-material-outline-power-settings-new"></i>
                  Logout</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- Navigation / End -->
      </div>
    </div>
  </div>
  <!-- Dashboard Sidebar / End -->
</template>

<script>
export default {};
</script>

<style scoped></style>
